import styled from 'styled-components'

type Props = {
	isVisible: boolean
	loaderDelay: number
}

export const Container = styled.div<Props>`
	position: fixed;
	top: 50%;
	left: 50%;
	width:  64px;
	height:  64px;
	transform: translate(-50%, -50%);
	z-index: 100;
	pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};

	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

	transition: opacity ${({ loaderDelay }) => loaderDelay}s;
`
